import { mergeObjectTypes } from '../cacheHelpers';

const PackageInfo = {
  merge: mergeObjectTypes
};

export default PackageInfo;
